import styled from "styled-components";
import { SideNav as CarbonSideNav } from "@carbon/react";
export const NavWrapper = styled.div `
	.cds--side-nav__overlay {
		display: none;
	}
`;
export const SideNav = styled(CarbonSideNav) `
	visibility: ${({ expanded }) => (expanded ? "visible" : "hidden")};
	display: grid;
	grid-auto-flow: row;
	grid-auto-rows: max-content 1fr;
	border-right: ${({ expanded }) => expanded ? "1px solid var(--cds-border-subtle)" : undefined};
	overflow-y: auto;
`;
